export const ticketsTiersStyle = {
	wrapper: {
		marginBottom: '24px',
		'@media (max-width: 1199.98px)': {paddingBottom: '80px'},
	},

	title: {
		marginBottom: '12px',
		textTransform: 'capitalize',
	},

	content: {
		display: 'flex',
		gap: '12px',
		flexDirection: 'column',
	},

	table: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	tableFields: {
		display: 'flex',
		gap: '12px',

		'@media (max-width: 767.98px)': {
			flexDirection: 'column',
		},
	},

	tableName: {
		maxWidth: '372px',
		width: '100%',
	},

	checkBox: {
		display: 'flex',
		gap: '24px',
		alignItems: 'center',
		marginBottom: '12px',
	},

	meals: {
		maxWidth: '200px',
		width: '100%',

		'@media (max-width: 767.98px)': {
			maxWidth: 'unset',
		},
	},

	names: {
		display: 'flex',
		gap: '12px',

		'@media (max-width: 767.98px)': {
			flexDirection: 'row',

			'& > div': {
				width: '50%',
			},
		},
	},

	data: {
		display: 'flex',
		gap: '12px',

		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
		},

		'& > div': {
			width: '33%',

			'@media (max-width: 639.98px)': {
				width: '100%',
			},
		},
	},
};
